<div class="grid-filter-sections">
    <div class="grid-filter-section menu" #filterBarMenu>
        <div>
            <div class="results" [class.has-results]="filterGroups().length">
                <h-grid-filter-section-header></h-grid-filter-section-header>
            </div>
            @if (filterGroups().length) {
            <h-grid-filter-section></h-grid-filter-section>
            }
        </div>
    </div>

    <div class="grid-filter-section tags" #filterBarTags>
        <div> <h-grid-filter-tags></h-grid-filter-tags> </div>
    </div>
</div>
